import * as React from 'react';
import { useEffect, useState } from 'react';
import Link from 'next/link'
import { be, IndexObject, strapi } from 'models/conent';
import markdownToHtml from 'lib/markdownToHtml'
import Header from 'components/_OldDesign/header';
import axios from 'axios';
import {
  FacebookIcon,
  FacebookShareButton,
  LineIcon, LineShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon, TwitterShareButton
} from 'next-share';
import moment from 'moment';
import style from 'styles/Content.module.scss';
import Subscribe from 'components/_OldDesign/subscribe';
import fetch from 'isomorphic-unfetch';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fetchStrapi, { fetchStrapiBySlug } from 'lib/fetchStrapi';
import { NextPageWithLayout } from '@pages/_app';
import OldLayout from '@components/_OldDesign/OldLayout';
import { Lang, useLocale } from '@components/Contexts/LocaleContext';
import { omitDeep } from 'lodash-omitdeep';

interface Object {
  data: IndexObject[];
}

// Search crawlers execute the page and used to be counted as readers: AdsBot,
// Applebot, Bytespider and bingbot accounted for roughly 900 of the view writes
// observed in production over six weeks.
const BOT_USER_AGENT = /bot|crawler|spider|bytespider|applebot|adsbot/i;

const Blog: NextPageWithLayout<{post:any;others:any}> = ({ post, others }) => {
  const [showNoti, setShowNoti] = useState(false);
  const [view, setView] = useState(null);
  const [url, setUrl] = useState(null);
  const {lang, setLang} = useLocale();

  const copyLink = () => {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = window.location.href;

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      dummy.readOnly = true;
      const range = document.createRange();
      range.selectNodeContents(dummy);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      dummy.setSelectionRange(0, 999999);
      document.execCommand('copy');
      document.body.removeChild(dummy);
    } else {
      navigator.clipboard.writeText(window.location.href);
    }

    setShowNoti(true)
    setTimeout(() => {
      setShowNoti(false)
    }, 2000)

  }

  const filteredBlog = () => {
    return others?.contents?.map(content => {
      const res = content?.categories?.map(category => post?.categories?.map(res => res.name).includes(category.name))
      if (res.some(obj => obj) && content.title !== post.title) {
        return content;
      }
    }).filter(obj => obj !== undefined);
  }

  function truncateString(str) {
    if (str?.length > 85) {
      return str.substring(0, 85) + '...';
    } else {
      return str;
    }
  }

  function calculateRead(item) {
    moment.locale(lang);
    return item ? (lang === 'th'
      ? 'อ่านเมื่อ ' + moment(item).fromNow() : moment(item).fromNow()?.toUpperCase() + ' READ')
      : null;
  }

  useEffect(() => {
    setLang((localStorage.getItem('lang') ?? 'th') as Lang);
    setUrl(window.location.href);

    if (BOT_USER_AGENT.test(navigator.userAgent)) {
      setView(Number(post?.view ?? 0));
      return;
    }

    // documentId, not the numeric id: Strapi 5 recreates the published row
    // on every publish with a fresh id, which would 404 this call.
    axios.post(`${ be }/api/blogs/${ post.documentId ?? post.id }/view`)
      .then(res => {
        setView(Number(res.data?.view ?? 0));
      })
      .catch(() => {
        setView(Number(post?.view ?? 0));
      });
  }, [post])
  
  return <>
    { showNoti ? <div
      className="top-32 sm:top-20 right-3 fixed w-1/3 sm:w-1/5 z-50 border-t-4 rounded-b px-4 py-3 shadow-md bg-blue-100 border-blue-500 text-blue-900"
      role="alert"
      data-aos="fade-left"
      data-aos-easing="linear"
      data-aos-duration="300">
      <div className="flex">
        <p className="font-bold text-3xl sm:text-lg">Copied!</p>
      </div>
    </div> : '' }
    <Header content={ { content: post?.detailTH, title: post?.title, image: (be + post?.image?.url) } }/>
    <div
      className="w-full mt-24 sm:mt-20 md:mt-16 xl:mt-10 bg-cover bg-center bg-no-repeat blog-banner"
      style={ { backgroundImage: `url(${ strapi }${ post?.image?.url })` } }>
    </div>
    <div className="text-left text-dark-blue text-webkit-center lg:px-48">
      <div className="w-20 2xl:w-16 fixed" style={ { right: '6.5px', top: '30%' } }>
        <div className="my-1 text-3xl sm:text-2xl md:text-xl lg:text-lg font-medium text-center">Share this</div>
        <div className="grid space-y-2 w-max mx-auto">
          <FacebookShareButton url={ url } className="kiki">
            <FacebookIcon size={ 32 } bgStyle={ { fill: '#0b273e' } } round className="mr-1 custom-icon"/>
          </FacebookShareButton>
          <TwitterShareButton url={ url } className="kiki">
            <TwitterIcon size={ 32 } bgStyle={ { fill: '#0b273e' } } round className="mr-1 custom-icon"/>
          </TwitterShareButton>
          <LineShareButton url={ url } className="kiki">
            <LineIcon size={ 32 } bgStyle={ { fill: '#0b273e' } } round className="mr-1 custom-icon"/>
          </LineShareButton>
          <LinkedinShareButton url={ url } className="kiki">
            <LinkedinIcon size={ 32 } bgStyle={ { fill: '#0b273e' } } round className="mr-1 custom-icon"/>
          </LinkedinShareButton>
          <button className="bg-transparent border-none p-0 cursor-pointer outline-none" onClick={ () => copyLink() }>
            <img src="/images/link-icon.svg"
              width="32" height="32"
              className="custom-icon"
              alt="copy link"
              loading="lazy"/>
          </button>
        </div>
      </div>
      <h1 className="text-5xl text-primary text-center sm:text-4xl w-11/12 lg:w-full mt-24 xl:mt-24 mb-5"
        style={ { lineHeight: '4rem' } }>
        { post?.title }
      </h1>
      <div className="grid grid-cols-3 align-self-center w-5/6 md:w-1/2">
        <Link href="/issues">
          <div className="bg-dark-blue border-dark-blue border-2 2xl:border-4 text-center text-white py-4 md:py-1">
            <span className="text-3xl md:text-lg lg:text-xl cursor-pointer">Issues</span>
          </div>
        </Link>
        <div className="col-span-2 border-dark-blue border-2 2xl:border-4 text-center py-4 md:py-1">
          <span className="text-3xl md:text-lg lg:text-xl">{ post?.issue?.month || '-' }</span>
        </div>
        <Link href={ '/issues/' + post?.issue?.id + '-' + post?.issue?.theme }>
          <div
            className="col-span-3 border-dark-blue border-t-0 border-2 2xl:border-4 2xl:border-t-0 text-center py-5 sm:py-3 2xl:py-2">
            <span className="text-5xl md:text-4xl 2xl:text-3xl cursor-pointer">{ post?.issue?.theme || '-' }</span>
          </div>
        </Link>
      </div>
      <div className="mt-5 text-3xl md:text-xl w-5/6 md:w-3/4 flex justify-center" style={ { lineHeight: '3rem' } }>
        <span className="mr-2">Categories:</span>
        <div className="wrap-anywhere text-left w-auto">
          { post?.categories?.map((res, i) => <Link key={ i }
              href={ '/categories/' + res?.id + '-' + res?.name }>
            <span className={ `underline cursor-pointer ${ i < post.categories?.length ? 'pr-3' : '' }` }>
              { `#${ res.name }` }
            </span>
            </Link>
          ) }</div>
      </div>
      <div className="mt-2 md:mt-0 text-2xl sm:text-xl md:text-base w-5/6 md:w-1/2 font-light">
        Inspired by: { post?.inspired || '-' }
      </div>
      <div className="mt-4 text-3xl md:text-xl w-5/6 md:w-1/2">
        <FontAwesomeIcon icon={ faEye } className="self-center mr-1 fa-sm my-auto"/>
        { view } Views
      </div>
      <hr className="border-dark-blue mt-12 mx-12 sm:mx-44 lg:mx-20" style={ { 'borderWidth': '1px' } }/>
      <div
        className="px-24 md:px-36 py-12 md:py-16 text-4xl sm:text-3xl md:text-2xl lg:text-lg xl:text-base font-light text-left leading"
        dangerouslySetInnerHTML={ { __html: post?.description } }/>
    </div>
    <div className="text-left text-dark-blue mx-12 lg:mx-24 mt-5 mb-32 lg:mb-20">
      <div className="text-5xl md:text-4xl font-bold mb-10">You may also like</div>
      { filteredBlog()?.length ? <div className="grid grid-cols-1 lg:grid-cols-2">
        { filteredBlog()?.map((item, index) =>
          <span key={ index }>
            { index < 4 ? <div className={ `${ index < 3 ? 'mb-14 lg:mb-12' : '' } md:flex` }>
              <Link href={ '/blogs/' + item.id + '-' + item.url }>
                <div>
                  <img src={ strapi + item.imageMobile?.url } loading="lazy"
                    alt={ item.title }
                    className={ `${ style.minW15 } lg:hidden h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer` }/>
                  <img src={ strapi + item.image?.url } loading="lazy"
                    alt={ item.title }
                    className={ `${ style.minW15 } hidden lg:block h-96 md:h-60 lg:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer` }/>
                </div>
              </Link>
              <div className="mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between">
                <Link href={ '/blogs/' + item.id + '-' + item.url }>
                  <div className="text-4xl sm:text-3xl md:text-2xl lg:text-lg font-normal leading-snug cursor-pointer">
                    { truncateString(item.title) }
                  </div>
                </Link>

                <div className="text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2">
                  { moment(item.created_at).format('MMM DD, YYYY').toUpperCase() }
                  { item.timeStamp ? <span className="mx-3">&#8226;</span> : '' }
                  { calculateRead(item.timeStamp) }
                  <div>
                    { item.categories.map((tag, i) =>
                      <Link key={ i } href={ '/categories/' + tag.id + '-' + tag.name }>
                        <span>
                          { i < 3 ? <div key={ i }
                            className="mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-base xl:text-xs cursor-pointer mr-2">
                            { tag.name }</div> : ''
                          }
                        </span>
                      </Link>
                    ) }
                  </div>
                </div>
              </div>
            </div> : '' }
          </span>
        ) }
        { filteredBlog().length < 4 ? <>{ others?.contents?.filter(item => item.name === 'article')?.sort(() => Math.random() - 0.5).map((item, index) =>
          <span key={ index }>
            { index < 4 - filteredBlog().length ? <div className={ `${ index < 3 ? 'mb-14 lg:mb-12' : '' } md:flex` }>
              <Link href={ '/blogs/' + item.id + '-' + item.url }>
                <div>
                  <img src={ strapi + item.imageMobile?.url } loading="lazy"
                    alt={ item.title }
                    className={ `${ style.minW15 } lg:hidden h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer` }/>
                  <img src={ strapi + item.image?.url } loading="lazy"
                    alt={ item.title }
                    className={ `${ style.minW15 } hidden lg:block h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer` }/>
                </div>
              </Link>
              <div className="mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between">
                <Link href={ '/blogs/' + item.id + '-' + item.url }>
                  <div className="text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug cursor-pointer">
                    { truncateString(item.title) }
                  </div>
                </Link>

                <div className="text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2">
                  { moment(item.created_at).format('MMM DD, YYYY').toUpperCase() }
                  { item.timeStamp ? <span className="mx-3">&#8226;</span> : '' }
                  { calculateRead(item.timeStamp) }
                  <div>
                    { item.categories.map((tag, i) =>
                      <Link key={ i } href={ '/categories/' + tag.id + '-' + tag.name }>
                        <span>
                          { i < 3 ? <div key={ i }
                            className="mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-base xl:text-xs cursor-pointer mr-2">
                            { tag.name }</div> : ''
                          }
                        </span>
                      </Link>
                    ) }
                  </div>
                </div>
              </div>
            </div> : '' }
          </span>
        ) }</> : '' }
      </div> : <div className="grid grid-cols-1 lg:grid-cols-2">
        { others?.contents?.filter(item => item.name === 'article')?.sort(() => Math.random() - 0.5).map((item, index) =>
          <span key={ index }>
            { index < 4 ? <div className={ `${ index < 3 ? 'mb-14 lg:mb-12' : '' } md:flex` }>
              <Link href={ '/blogs/' + item.id + '-' + item.url }>
                <div>
                  <img src={ strapi + item.imageMobile?.url } loading="lazy"
                    alt={ item.title }
                    className={ `${ style.minW15 } lg:hidden h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer` }/>
                  <img src={ strapi + item.image?.url } loading="lazy"
                    alt={ item.title }
                    className={ `${ style.minW15 } hidden lg:block h-96 md:h-60 xl:h-40 rounded-xl w-full md:w-96 lg:w-52 object-cover cursor-pointer` }/>
                </div>
              </Link>
              <div className="mt-10 md:mt-0 px-0 md:px-6 relative flex flex-col justify-between">
                <Link href={ '/blogs/' + item.id + '-' + item.url }>
                  <div className="text-4xl sm:text-3xl md:text-3xl lg:text-lg font-normal leading-snug cursor-pointer">
                    { truncateString(item.title) }
                  </div>
                </Link>

                <div className="text-2xl md:text-xl lg:text-sm font-light mt-5 xl:mt-2">
                  { moment(item.created_at).format('MMM DD, YYYY').toUpperCase() }
                  { item.timeStamp ? <span className="mx-3">&#8226;</span> : '' }
                  { calculateRead(item.timeStamp) }
                  <div>
                    { item.categories.map((tag, i) =>
                      <Link key={ i } href={ '/categories/' + tag.id + '-' + tag.name }>
                        <span>
                          { i < 3 ? <div key={ i }
                            className="mt-1 inline-block py-3 px-5 md:py-2 lg:py-1 md:px-3 border-2 rounded-2xl text-white bg-dark-blue font-light text-2xl md:text-lg lg:text-base xl:text-xs cursor-pointer mr-2">
                            { tag.name }</div> : ''
                          }
                        </span>
                      </Link>
                    ) }
                  </div>
                </div>
              </div>
            </div> : '' }
          </span>
        ) }
      </div>
      }
    </div>

    <div className="px-12 xl:px-24">
      <hr className="border-dark-blue my-12" style={ { 'borderWidth': '1px' } }/>
    </div>
    
    {/*<Subscribe/>*/ }
    <Subscribe/>
  </>
}

export async function getStaticProps({ params, preview = null }) {
  let contents = await fetchStrapi('/blogs', 2);
  contents = omitDeep(contents, ['description', 'descriptionTH', 'formats', 'detail', 'detailTH']);
  const routeParam = params.id
  const data = await getPreviewPost(routeParam)
  const blog = await markdownToHtml(data || '')
  return {
    props: {
      post: {
        ...data,
        blog,
      },
      others: {
        contents,
      }
    },
  }
}

export async function getStaticPaths() {
  const allPosts = await getAllPosts()
  
  return {
    paths: allPosts?.map((post) => `/blogs/${ post.id }-${ (post.url ?? '').trim() }`) || [],
    fallback: true,
  }
}


async function getPreviewPost(routeParam): Promise<any> {
  try {
    let data = await fetchStrapiBySlug('/blogs', 'url', routeParam, 2);
    if (data.description) {
      data.description = data.description.replaceAll('https://codium.co/strapi', strapi)
    }
    return data;
  } catch (error) {
    return {
      props: {
        data: JSON.stringify(error),
      },
    };
  }
}

async function getAllPosts(): Promise<any> {
  // const response = await fetch(strapi + '/blogs');
  return await fetchStrapi('/blogs', 1);
}

Blog.getLayout = (page: React.ReactElement) => {
  return <OldLayout>{page}</OldLayout>;
};

export default Blog;